import * as React from "react"
import type { SVGProps } from "react"
const SvgVennDiagram = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M15.88 5.71a7 7 0 1 1-3 13.33q-1.38.66-3 .67a7 7 0 1 1 3-13.32q1.37-.66 3-.68m-6 2a5 5 0 1 0 1 9.9 7 7 0 0 1 0-9.8q-.5-.1-1-.1m6 0q-.52 0-1 .1a7 7 0 0 1 0 9.8q.48.1 1 .1a5 5 0 0 0 0-10"
    />
  </svg>
)
export default SvgVennDiagram
